/**
 * Polyfill for crypto.randomUUID() in non-secure contexts.
 *
 * crypto.randomUUID() is only available in "secure contexts" (HTTPS or localhost).
 * When the app is accessed via a plain HTTP network IP (e.g. 172.x.x.x:8080),
 * it's undefined. This polyfill uses crypto.getRandomValues() (which IS available
 * in all modern browsers regardless of secure context) to generate a compliant
 * UUID v4.
 *
 * Must be imported before any code that calls crypto.randomUUID().
 */
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    // Set version 4 (bits 12-15 of time_hi_and_version)
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    // Set variant 1 (bits 6-7 of clock_seq_hi_and_reserved)
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` as `${string}-${string}-${string}-${string}-${string}`;
  };
}
